import { cn } from "@/lib/utils"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { motion } from "motion/react"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

export const shakeAnimation = {
  shake: {
    x: [0, -3, 3, -3, 3, 0],
    transition: {
      duration: 0.7,
    },
  },
}

export function FormField({ label, name, type, placeholder, options, required, value, onChange, onBlur, errors, className, ...props }) {
  const error = errors && errors[name]

  return (
    <motion.div
      className={cn("flex flex-col", className)}
      animate={error ? "shake" : ""}
      variants={shakeAnimation}
      {...props}
    >
      <Label htmlFor={name} className="mb-1.5">{label}</Label>
      {type === 'select' ? (
        <Select onValueChange={onChange}>
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent>
            {options.map((option) => (
              <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <Input type={type} id={name} name={name} required={required} placeholder={placeholder} value={value} onChange={onChange} onBlur={onBlur} />
      )}
      {error && <p className="text-[0.8rem] mt-1 font-medium text-destructive first-letter:uppercase">{error}</p>}
    </motion.div>
  )
}
